import { ParticipantTypeEnum } from "./_models/interfaces/messaging.interfaces";

/**
 * Utility function to get the image path for a participant type
 * @param participantType - The participant type enum value
 * @returns The path to the corresponding image
 */
export function getParticipantImagePath(
  participantType: ParticipantTypeEnum
): string {
  const basePath = "assets/images/roles";

  switch (participantType) {
    case ParticipantTypeEnum.DPM_ADMIN:
      return `${basePath}/admin.webp`;
    case ParticipantTypeEnum.DPM_LAWYER:
      return `${basePath}/lawyer.webp`;
    case ParticipantTypeEnum.DPM_PARTNER:
      return `${basePath}/partner.webp`;
    case ParticipantTypeEnum.DPM_PERSON:
    default:
      return `${basePath}/person.webp`;
  }
}
